module.exports = __webpack_public_path__ + "img/lens-150-plus-01.c3052ade.png";